Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-speedex-track-trace'), $speedexForm = $('.x-speedex-form');

    var model = null;
    var wrapper = $wrapper;

    if ($wrapper.length < 1)
        return;

    var speedexForm = $speedexForm.get(0);

    var formData = {
        voucherCode: ''
    };

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function update() {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("SpeedexTrackTraceReview", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        wrapper.html(html);
    };


    $speedexForm.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        speedexForm.submit();
    });


    speedexForm.submit = function () {
        speedexForm.loading(true);

        formData.voucherCode = $('input[name="voucherCode"]').val();

        Vendd.MessageBus.publishAsync(wrapper.get(0), new Vendd.SpeedexTrackTrace.Messages.GetSpeedexTrackTraceModel(formData.voucherCode));
    };

    speedexForm.loading = function (loading) {
        if (loading) {
            $speedexForm.addClass('x-loading');
        } else {
            $speedexForm.removeClass('x-loading');
        }
    };

    Vendd.MessageBus.subscribe(Vendd.SpeedexTrackTrace.Messages.GetSpeedexTrackTraceModelSuccess, wrapper, function (envelope) {

        model = envelope.message.data.model;
        wrapper.update();
    });

});